module.exports = __webpack_public_path__ + "img/scene4-1.80842e57.jpg";